import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import CookieValue from "../../../utils/cookie_value";
import Cookies from "universal-cookie";
// import UserOptionsDropdown from './UserOptionsDropdown';
import TextInput from "../../TextInput";
import { disable } from "debug";
import { options } from "colorette";
import { select } from "async";

const api_base = process.env.API_URL;
const client_base = process.env.BASE_URL;

export default class UpdatePasswordMainContainer extends Component {
  constructor(props) {
    super(props);
    console.log("PROPS MATCH PARAMS", props.match);
    const urlParams = new URLSearchParams(location.search);
    for (const [key, value] of urlParams) {
      console.log(`${key}:${value}`);
    }
    this.state = {
      // Attempt to pull userId from url. If that fails, assume it was passed in as a prop
      // For more information about props.match.params see https://v5.reactrouter.com/web/api/match
      id: props.match ? props.match.params.userId : props.currentUserId,
      full_name: "",
      // edit_mode: this.editMode(),
      data_ready: false,
      password: "",
      password_confirmation: "",
      notice_message: "",
      display_notice: false,
      display_error: false,
      currentUserRole: props.currentUserRole,
      can_update: false,
      //True when forcing user to update password upon first login
      redirectOnSuccess: props.redirectOnSuccess,
    };
  }

  // editMode = () => {
  //   return (this.props.currentUserRole === "ADMIN" || this.props.currentUserId == this.props.match.params.userId);
  // }

  componentDidMount = () => {
    this.fetchUser()
      .then(() => {
        this.setState({ data_ready: true });
      })
      .catch((err) => {
        if (err === "Unauthorized") {
          const cookies = new Cookies();
          cookies.remove("user_auth");
          this.props.history.push("/log_in");
        } else {
          // this.setState({display_error: true})
          this.displayError(err);
        }
      });
  };

  componentDidUpdate = (prevProps, prevState, snapshot) => {
    if (this.props !== prevProps) {
      this.setState({
        userRole: this.props.currentUserRole,
        // edit_mode: this.editMode(),
      });
    }
  };

  fetchUser = () => {
    let { id } = this.state;
    return new Promise((resolve, reject) => {
      let url = api_base + "users/" + id + "/edit";
      try {
        fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: "Bearer " + CookieValue(),
          },
        }).then((res) => {
          if (res.status === 201 || res.status === 200) {
            res.json().then((data) => {
              // console.log("data:", data)
              if (data["role_lookup"] == null && data["role_opts"].length > 0) {
                data["role_lookup"] = data["role_opts"][0];
              }
              if (
                data["univ_lookup"] == null &&
                data["university_opts"].length > 0
              ) {
                data["univ_lookup"] = data["university_opts"][0];
              }
              this.setState(data);
              resolve();
            });
          } else {
            reject(res.statusText);
          }
        });
      } catch (err) {
        reject(err);
      }
    });
  };

  updatePassword = () => {
    let body = {
      skip_session_flag: true,
      user: {
        password: this.state.password,
        password_confirmation: this.state.password_confirmation,
      },
    };
    const url = api_base + "users/" + (this.state.id ? this.state.id : "");
    const reqOptions = {
      method: this.state.id ? "PATCH" : "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + CookieValue(),
      },
      body: JSON.stringify(body),
    };
    this.api_call(url, reqOptions)
      .then((data) => {
        console.log("resp data");
        console.log(data);
        if (data.success) {
          if (this.state.redirectOnSuccess) {
            location.reload();
          } else {
            this.displayNotice("Success: updated password.");
          }
        } else {
          this.displayError(data.errors || data.data.errors);
        }
      })
      .catch((err) => {
        this.displayError(`Failed to update password with error: ${err}.`);
      });
  };

  handleTextChange = (key, event) => {
    let state = this.state;
    state[key] = event.target.value;
    this.setState(state);
  };

  api_call = (url, reqOptions) => {
    return new Promise((resolve, reject) => {
      try {
        fetch(url, reqOptions).then((res) => {
          res.json().then((data) => {
            resolve(data);
          });
        });
      } catch (err) {
        reject(err);
      }
    });
  };

  displayError = (error) => {
    console.log("error", error);
    let message;
    if (error instanceof Array) {
      message = error.join(", ");
    } else if (error instanceof String) {
      message = error;
    } else if (error instanceof Object) {
      message = Object.keys(error)
        .map((key) => {
          return `${key} ${error[key]}`;
        })
        .join(" - ");
    }
    this.setState({
      data_ready: true,
      notice_message: message,
      display_error: true,
      display_notice: false,
    });
  };

  displayNotice = (message) => {
    this.setState({
      data_ready: true,
      notice_message: message,
      display_error: false,
      display_notice: true,
    });
  };

  render() {
    let {
      id,
      full_name,
      // edit_mode,
      data_ready,
      password,
      password_confirmation,
      notice_message,
      display_notice,
      display_error,
      can_update,
    } = this.state;

    const page_title = "Change Password for " + full_name;

    const notice =
      display_error || display_notice ? (
        <div
          role="alert"
          className={
            "card inner-buffer " +
            (display_error ? "alert alert-danger" : "alert alert-success")
          }
        >
          {notice_message}
        </div>
      ) : (
        ""
      );

    const pwForm = (
      <div className="card inner-buffer w-50">
        <TextInput
          valText={password}
          inputType="password"
          editMode={can_update}
          fieldName="password"
          labelText="Password:"
          handleChange={this.handleTextChange}
        />
        <TextInput
          valText={password_confirmation}
          compareVal={password}
          inputType="password"
          editMode={can_update}
          fieldName="password_confirmation"
          labelText="Password Confirmation:"
          handleChange={this.handleTextChange}
        />
        <button
          className="btn btn-primary col-2 mt-4"
          type="submit"
          onClick={this.updatePassword}
        >
          Save
        </button>
      </div>
    );

    const accessDenied = (
      <div className="alert alert-danger">
        You do not have permission to edit this user.
      </div>
    );

    return data_ready ? (
      <div className="container">
        {notice}
        <h1>
          {page_title}
          <a href={process.env.BASE_URL + "user/" + id}>
            <button
              className="btn btn-info xs-font ml-3"
              style={{ lineHeight: "100%" }}
            >
              Edit User
            </button>
          </a>
        </h1>
        {can_update ? pwForm : accessDenied}
      </div>
    ) : (
      <div className="spinner"></div>
    );
  }
}
